import { getRtlScrollAxisType } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { BrowserService } from '../browser/browser.service';

/**
 * Replacement for original enum from @angular/cdk/platform.
 * In CDK v9 it has been changed to `const enum` causing Jest to fail due to undefined enum values
 * as long Jest is configured with `isolatedModules: true` (which is the current case).
 */
export enum RtlScrollAxisType {
  NORMAL = 0,
  NEGATED = 1,
  INVERTED = 2
}

export enum TextDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

@Injectable({
  providedIn: 'root'
})
export class DirectionService {
  private readonly directionIsRtl: boolean;

  constructor(@Inject(DOCUMENT) document: Document, private readonly browserService: BrowserService) {
    this.directionIsRtl = !!document.querySelector(':root[dir=rtl]');
  }

  /**
   * returns direction of the page
   * @returns {string}
   */
  get direction(): string {
    return this.isRtl ? TextDirection.RTL : TextDirection.LTR;
  }

  /**
   * will check for presence of dir="rtl" on root element
   * @returns true|false {boolean}
   */
  get isRtl(): boolean {
    return this.directionIsRtl;
  }

  /**
   * returns if the page is not right to left
   * @returns {boolean}
   */
  get isLtr(): boolean {
    return !this.isRtl;
  }

  get rtlScrollAxisType(): RtlScrollAxisType {
    /*
     * There is a bug that for Safari the wrong scrollAxisType is reported (INVERTED instead of NEGATED)
     * PR is currently pending. Once this is fixed we can remove the extra check for Safari.
     * https://github.com/angular/components/issues/14609
     */
    return this.browserService.isSafari && this.browserService.isMac
      ? RtlScrollAxisType.NEGATED
      : (getRtlScrollAxisType() as unknown as RtlScrollAxisType);
  }
}
